import request from "@/http"

import {
  TReportPark,
  TParkConf,
  TReportFlow,
  TIndustryList,
  TPoiCates,
  THeatItem,
} from "./interfacePark"
const API_LOCAL = window.location.origin + window.location.pathname
/**
 *  获取园区列表
 */
export async function getParks(): Promise<any> {
  try {
    let list: TParkConf[] = await request.get(
      API_LOCAL + "/data/park/park.json"
    )
    let geo = {
      type: "FeatureCollection",
      features: [],
    }

    list.forEach((item) => {
      geo.features.push({
        type: "Feature",
        properties: {
          name: item.name,
          key: item.key,
          center: item.center,
          labels: item.labels,
          color: item.color || "#48FFDF",
          area: item.area,
        },
        geometry: { type: "MultiPolygon", coordinates: item.polygon },
      })
    })
    geo.features.sort((a, b) => b.properties.area - a.properties.area)
    return { geo, list }
  } catch (error) {
    console.log("error", error)
  }
}

/**
 * 查看园区报告
 *
 * @export
 * @param {string} id
 * @returns {Promise<TReportPark>}
 */
const parkReportCache = {}
export async function getParkReport(key: string): Promise<TReportPark> {
  if (parkReportCache[key]) {
    return parkReportCache[key]
  }
  try {
    const result: TReportPark = await request.get(
      API_LOCAL + "/data/park/profile/" + key + ".json"
    )
    parkReportCache[key] = result
    return result
  } catch (error) {
    console.log(`WAYZ: previewReport -> error`, error)
  }
}
/**
 * 产业列表
 */
export async function getIndustry(): Promise<TIndustryList> {
  try {
    const result: TIndustryList = await request.get(
      API_LOCAL + "/data/park/industry.json"
    )
    return result
  } catch (error) {
    console.log(`WAYZ: getIndustry -> error`, error)
  }
}
/**
 * poi
 */
export async function getPoi(): Promise<TPoiCates> {
  try {
    const result: TPoiCates = await request.get(
      API_LOCAL + "/data/park/poi.json"
    )
    return result
  } catch (error) {
    console.log(`WAYZ: getpoi -> error`, error)
  }
}
/**
 * 人才流入流出
 */
export async function getFlows(key: string): Promise<TReportFlow> {
  try {
    const result: TReportFlow = await request.get(
      API_LOCAL + "/data/park/flow/" + key + ".json"
    )
    return result
  } catch (error) {
    console.log(`WAYZ: getFlows -> error`, error)
  }
}

let heatCache = {}
export async function heat(key: string): Promise<THeatItem[]> {
  if (heatCache[key]) {
    return heatCache[key]
  }
  try {
    const result: THeatItem[] = await request.get(
      API_LOCAL + "/data/park/heat/" + key + ".json"
    )
    heatCache[key] = result
    return result
  } catch (error) {
    console.log(`WAYZ: heat -> error`, error)
  }
}
